<section class="about-background">
    <section class="about-container">
        <h2>Sobre mí</h2>
        <section class="about">
            <div class="picture">
                <img src="https://firebasestorage.googleapis.com/v0/b/portafolio-personal-264fb.appspot.com/o/background%2Fyo.jpg?alt=media&token=e071cd36-3cf3-4ec7-b3cd-1f41f5927282" alt="">
            </div>
            <div>
                <p>
                    Soy Cristian Refugio Covarrubias Patiño, me apasiona la tecnología y aprender
                    cosas nuevas. Me gusta tocar guitarra y acordeón aunque no
                    me considere tan bueno en ello (me gusta intentarlo). Cuando
                    tenía 7 años reparé una computadora sin tener conocimientos
                    de computación, yo solo decía "Sólo hay
                    que seguir lo que dice el manual". Había muchas cosas que no
                    comprendía pero trataba de buscar manuales de ayuda (no conocía
                    internet aún, todo lo quería sacar de encarta 2007).
                </p>
                <p>
                    A los 11 años compré unos juegos para celular en la feria
                    del pueblo. Me llamaba la atención que el tipo instalaba algo
                    y después borraba el archivo instalador. Comenzaba a buscar en
                    un cyber que eran los formatos de archivos y encontré argim.net
                    la pagina donde el tipo descargaba los juegos y comenzaba a venderlos
                    por mi cuenta.
                </p>
                <p>
                    Unos meses después conocí jimdo.net y con un cms puse en linea
                    adictos.jimdo.net que desafortunadamente ya no está disponible. Era una
                    web en la que colocaba gratis todos los juegos Java que me gustaban
                    y las imágenes que más se compartían en la secundaría donde estudiaba (
                    obviamente nadie lo vió porque no tenían internet mis amigos,
                    ni fama los sitios web entre los chicos de la secundaria).
                </p>
                <p>
                    Tiempo después quería hacer cosas en mi página como colocar el clima y
                    un chat que tenía en https://xat.com/losporta entonces investigué en
                    http://www.forosdelweb.com/ y había que usar HTML, así que había que
                    poner manos a la obra. Obviamente no lo hice hahaha!!! esas cosas eran
                    de otro mundo, muy avanzado para mi.
                </p>
                <p>
                    A los 14 años tomé un curso presencial de 1 año, patrocinado por mi hermana 
                    nos enseñaron HTML, CSS, Formateo de PC, Computación básica. Era
                    el momento ideal para actualizar mi sitio web pero olvidé el correo y
                    la contraseña.
                </p>
                <p>
                    Ingresé a la universidad, a la carrera de Ingeniería en Teleinformática
                    aprendí redes y desarrollo de software ( C, C++, Java, MySQL). Durante el
                    proceso de la universidad ingresé como trabajador externo de 2015-2016
                    en el área de mantenimiento de cómputo y redes. Para julio del 2016 pasé al
                    área de servidores del CUCSur y comencé a trabajar en el portal de la universidad
                    con el CMS de Drupal 7
                </p>
                <p>
                    En el 2017 aprox. trabajé en el área de multimedia haciendo diseños simples
                    con Photoshop CC, y migrando el LMS de la universidad con Moodle 3.5. Durante el mismo
                    año logramos el reconocimiento por ser el primer centro de la Universisdad de Guadalajara en
                    alcanzar el 100% de accesibilidad ante la w3C.
                </p>
                <p>
                    Inicié un proyecto junto con unos compañeros de la carrera para desarrollar un
                    software punto de venta con Java + NetBeans y venderlo a un restaurante, a partir
                    de ese punto hasta la fecha, comenzamos a tener trabajos particulares (formateos de pc, reparación
                    de celulares, tablets, desarrollo de sitios web y asesorías de TI para pequeñas empresas).
                    En el 2018 ingresé a laborar como trabajador externo de la Cooperativa Financiera
                    "Caja SMG" en El Grullo Jalisco México, justo 1 día después de egresar de la carrera. Estuve en la empresa
                    por 1 año completo trabajando módulos de software con Java EE como FullStack.
                </p>
                <p>
                    En Noviembre de 2019 ingresé a trabajar a la Clinica dental "Solorio Dental" como desarrollador
                    de software y tecnico de redes enfrentandome a nuevos retos técnicos y aprendiendo cosas extras
                    como el modelado 3D para el ámbito dental, integrando tecnologías de desarrollo de frontend y backend por separado. 
                    Utilizando tecnologías como Angular y Node JS así como Firebase.
                </p>
                <p>
                    En Mayo de 2020 la pandemia lo cambió todo dejándome un mes en el que creí no tener trabajo. Ese mismo mes
                    por medio de nuestro emprendimiento conseguimos construir algunos proyectos de software para ayudar a negocios
                    y también fui invitado a colaborar por un mes en Grupo Pepsico para un proyecto de migración de equipos inteligentes
                    para el levantamiento de pedidos de la emrpesa, fue un mes duro de madrugadas y trabajo pero fue de los mejores meses del año.
                </p>
                <p>
                    Por esas mismas fechas fui invitado al programa Platzi Master <a href="https://www.youtube.com/watch?v=EIFz1vABdzc&t=1582s">explacación del programa</a> al cohort 3
                    donde hasta el día de hoy me han preparado con mentores especializados y profesores 100% dedicados a mi crecimiento profesional. El roceso también no ha sido nada sencillo
                    ya que inicialmente fueron unas semanas de selección basada en rendimiento y cursos intensivos (llegaba a hacer hasta 6 cursos por semana). Pero todo ha rendido frutos
                    me prometieron que podría mejorar mis ingresos y ha sucedido, he conseguido un empleo superior al que tenía anteriormente y la pandemia me ha dado cosas increibles que no 
                    hubiese creido posibles un año antes. Actualmente estoy preparando mi nivel de ingles para seguir escalando en mi carrera profesional
                </p>
                <p>
                    De diciembbre de 2020 a la fecha, después de trabajo duro, preparación en Master y procesos de selección retadores, logré ingresar a una startup colombiana de la categoría 
                    Grocery en e-commerce llamada <a href="https://www.cheeseokay.com">CheeseOkay</a> donde me han dado la oportunidad de empezar desde abajo manteniendo el core de la plataforma
                    y hoy en día dirijo el proceso de desarrollo y la implementación del core 2.0 de la misma plataforma como Jefe de Tecnología.  
                </p>
            </div>
        </section>
    </section>
</section>
